export const TIPO_CONSUMIDOR_FINAL_NO_APLICA = 10;
export const TIPO_CONSUMIDOR_FINAL_MISMO_CLIENTE = 20;
export const TIPO_CONSUMIDOR_FINAL_ESPECIFICO = 30;

const ID_OPCION_NO_APLICA = "NO_APLICA";
const ID_OPCION_MISMO_CLIENTE = "MISMO_CLIENTE";

// Arma las opciones del select: primero N/A y el mismo cliente, luego los consumidores del cliente
export const construirOpcionesConsumidorFinal = (
    cliente,
    consumidoresFinales,
    search,
) => {
    const busqueda = search ? search.toLowerCase() : "";

    const opcionesSinRegistro = [
        {
            id: ID_OPCION_NO_APLICA,
            nombre: "N/A",
            tipo: TIPO_CONSUMIDOR_FINAL_NO_APLICA,
        },
    ];

    if (cliente) {
        opcionesSinRegistro.push({
            id: ID_OPCION_MISMO_CLIENTE,
            nombre: cliente.nombre,
            tipo: TIPO_CONSUMIDOR_FINAL_MISMO_CLIENTE,
        });
    }

    const opciones = opcionesSinRegistro.filter(
        (opcion) => opcion.nombre.toLowerCase().indexOf(busqueda) >= 0,
    );

    consumidoresFinales.forEach((consumidorFinal) => {
        opciones.push({
            id: consumidorFinal.id,
            nombre: consumidorFinal.nombre,
            tipo: TIPO_CONSUMIDOR_FINAL_ESPECIFICO,
        });
    });

    return opciones;
};
